import React, { PureComponent } from 'react'
import { CssBaseline } from '@material-ui/core'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import blue from '@material-ui/core/colors/blue'
import red from '@material-ui/core/colors/red'

import { isSignedInSelector, authDataSelector } from 'reduxModules/selectors/AuthSelectors'
import { snackbarActions } from 'reduxModules/actions/SnackbarActions'
import { authActions } from 'reduxModules/actions/AuthActions'
import { EnhancedSnackbar, EnhancedModal } from 'components'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: blue['900'],
    },
    secondary: {
      main: red['A200']
    }
  },
  overrides: {
    MuiPaper: {
      root: {
        transform: 'translateZ(0)',
        willChange: 'transform'
      },
    },
    MuiDialogTitle: {
      root: {
        textAlign: 'center'
      }
    },
    MuiDialog: {
      paperWidthSm: {
        maxWidth: '100%'
      }
    }
  },
  typography: {
    fontFamily: `'Play', sans-serif`,
    useNextVariants: true
  }
})

class MainLayoutCmp extends PureComponent {
  showOfflineSnack = () => this.props.showSnackbar({
    type: 'error',
    message: 'Втрачено з\'єднання з інтернетом!'
  })

  showOnlineSnack = () => this.props.showSnackbar({
    type: 'success',
    message: 'Інтернет з\'єднання відновленно! Будь ласка перезавантажте сторінку'
  })

  componentDidMount() {
    const { isSignedIn, authData, emailSignIn } = this.props

    if (isSignedIn) {
      emailSignIn(authData)
    }

    window.addEventListener("offline", this.showOfflineSnack)
    window.addEventListener("online", this.showOnlineSnack)
  }

  render() {
    const { children } = this.props

    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
        <EnhancedSnackbar />
        <EnhancedModal />
      </MuiThemeProvider>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  isSignedIn: isSignedInSelector,
  authData: authDataSelector
})

const mapDispatchToProps = {
  emailSignIn: authActions.emailSignIn,
  showSnackbar: snackbarActions.showSnackbar,
}

export const MainLayout = connect(mapStateToProps, mapDispatchToProps)(MainLayoutCmp)



// WEBPACK FOOTER //
// ./src/layouts/MainLayout/MainLayout.js